import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

export default class OpportunityLostReasonDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name = '';
}
